import {
  makePasswordResetLink,
  makeSignInLink,
  makeSignUpLink
} from "./common-routes/links";

export const linkToSignIn = () => makeSignInLink("");

export const linkToSignUp = () => makeSignUpLink("");
export const linkToSignUpInvite = () => "/sign-up-invite";
export const linkToSignUpParent = () => "/sign-up-parent";

export const linkToPasswordReset = () => makePasswordResetLink("");
